"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributes = void 0;
const routes_1 = require("../../routes");
const getAttributes = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ATTRIBUTES.path, {
        headers: params,
    });
    return response.data;
};
exports.getAttributes = getAttributes;
